async function fetchGraphQL(text, variables) {
  // Fetch data from GitHub's GraphQL API:
  const response = await fetch('https://lsyua7awa6.execute-api.us-east-1.amazonaws.com/v1/graphql', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${window.RzsgAuth.getToken()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: text,
      variables,
    }),
  });

  // Get the response as JSON
  return await response.json();
}

export default fetchGraphQL;